module.exports = __webpack_public_path__ + "media/application/images/newsletter-flower-small-50ddf22197db26e2ce131b1704b6af9e.png";